import {
  Link,
  Typography,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { green } from '@mui/material/colors';
import { MsgEmailProps } from '../../../../config/interfaces';

const ConfirmVerifyPage = (_props: MsgEmailProps) => {
  const { email } = _props;
  return (
    <>
      <CheckCircleIcon sx={{ color: green[600], fontSize: 200, mb: 6 }} />
      <Typography
        component="p"
        variant="body1"
        sx={{
          mb: 2,
          textAlign: 'justify'
        }}
      >
        Your Cinemahive.com account is active! Create, collaborate, and bring your production
        to life with our easy-to-use and automated tools. Say goodbye to busy-work
        and hello to more time for your craft.
      </Typography>
      <Typography
        component="p"
        variant="body1"
        sx={{
          mb: 2,
          textAlign: 'justify',
          width: '100%'
        }}
      >
        Need help? Contact us at <strong> hello@cinemahive.com. </strong>
        <br />
        Let's make movie magic together!
      </Typography>
      <Typography
        component="p"
        variant="body1"
        sx={{
          mb: 2,
          width: '100%'
        }}
      >
        Best regards,
        <br />
        The Cinemahive Team
      </Typography>
    </>
  )
};

export default ConfirmVerifyPage;
